<template>
  <div :class="formGroupClass">
    <slot name="before"/>
    <input
      class="form-control"
      :id="vesselKey"
      autocomplete="off"
      v-model="inputValue"
      @input="emit"
      @change="emit"
      @blur="emit"
      @keyup.delete="emit"
      :disabled="disabled"
    />
    <error-help-block :has-errors="hasInputErrors" :current-error="actualErrorMessage"/>
    <slot name="after"/>
  </div>
</template>

<script>
import applicationInputMixin from '../../../../mixins/applicationInputMixin'
import applicationFormMixin from '../../../../mixins/applicationFormMixin'
import passSectionMixin from '../../../../mixins/application-form/passSectionMixin'

export default {
  name: 'VesselInput',
  mixins: [
    applicationInputMixin,
    applicationFormMixin,
    passSectionMixin
  ],

  props: {
    inputLabel: {
      default: 'Наименование судна'
    },

    inputName: {
      default: 'vessel'
    },

    vesselId: {
      type: [Number],
      default: null
    }
  },

  computed: {
    vesselKey () {
      return `form-pass-vessel-${this.vesselId}`
    },

    inputError () {
      return this.hasInputErrors ? 'Введите наименование судна' : null
    },

    hasInputErrors () {
      return this.errors.vessels !== undefined && this.errors.vessels[this.vesselId] && this.errors.vessels[this.vesselId].find((err) => err === 'name')
    }
  }
}
</script>
